import { produce } from 'immer';
import { createReducer, on, Action } from '@ngrx/store';
import {
  initialMaestrosState,
  MaestrosState,
} from 'src/app/store/state/maestros.state';
import {
  saveCiudades,
  saveDepartamentos,
  saveTiposDeDocumento,
} from 'src/app/store/actions/maestros.action';

const reducer = createReducer(
  initialMaestrosState,
  on(saveTiposDeDocumento, (state, { tiposDeDocumento }) => ({
    ...state,
    tiposDeDocumento,
  })),
  on(saveCiudades, (state, { ciudades }) => ({
    ...state,
    ciudades,
  })),
  on(saveDepartamentos, (state, { departamentos }) => ({
    ...state,
    departamentos,
  }))
);

export function maestrosReducer(
  state = initialMaestrosState,
  action
): MaestrosState {
  return produce((draft: MaestrosState, formAction: Action) => {
    return reducer(draft, formAction);
  }, initialMaestrosState)(state, action);
}
